import { Box, Group, Radio, Stack, Text, useMantineTheme } from '@mantine/core';
import { IconCircle, IconCircleCheckFilled } from '@tabler/icons-react';

import classes from './ModelButton.module.css';

type ModelButtonProps = {
  description: string;
  icon: React.ReactElement;
  isActive: boolean;
  name: string;
  onClick: VoidFunction;
  withCheckmark?: boolean;
  isDisabled?: boolean;
};

export const ModelButton = ({
  description,
  icon,
  isActive,
  name,
  onClick,
  withCheckmark = false,
  isDisabled = false,
}: ModelButtonProps) => {
  const theme = useMantineTheme();

  const shouldDisplayDisabledCursor = isDisabled && !isActive;

  return (
    <Radio.Card
      checked={isActive}
      onClick={onClick}
      className={classes.root}
      p="sm"
      w={300}
      disabled={isDisabled}
      style={{ cursor: shouldDisplayDisabledCursor ? 'not-allowed' : 'pointer' }}
    >
      <Group gap="sm" wrap="nowrap" align="flex-start">
        <Box flex={1}>{icon}</Box>
        <Stack gap={5}>
          <Group w="100%" justify="space-between">
            <Text size="md">{name}</Text>
            {withCheckmark &&
              (isActive ? (
                <IconCircleCheckFilled size={20} stroke={1.5} color={theme.colors.validation[5]} />
              ) : (
                <IconCircle size={20} stroke={1.5} color={theme.colors.gray[6]} />
              ))}
          </Group>
          <Text size="xs" c="dimmed">
            {description}
          </Text>
        </Stack>
      </Group>
    </Radio.Card>
  );
};
